<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
  <v-container fluid fill-height align-start>
    <v-row  >
      <v-col md="12" lg="12" cols="12">
        <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Tipos de Carnet {{negocio.negocio}}</h1>
        <br/>
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Tipo Carnet se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Tipo Carnet se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Tipo Carnet se edito con éxito.
       </v-alert>
        <v-data-table
      :headers="headers"
      :items="TipoCarnets"
      sort-by="TipoCarnet"
      sort-desc
      class="elevation-1"
      :search="search"
      :loading="progr"
      no-data-text="No hay datos disponibles para mostrar."
      no-results-text="No hay resultados para la búsqueda."
      loading-text="Cargando... Por favor espere."
      style="background-color: #393E46;"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title>Tipos de Carnet</v-toolbar-title>
          <v-progress-circular
        indeterminate
        v-if="progr == true"
        color="primary"
      ></v-progress-circular>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Tipo Carnet</v-btn>
            </template>
            <v-card  color="#393E46">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-autocomplete
                      :items="Temporadas"
                      item-text="temporada"
                      v-model="editedItem.temporada"
                      label="Selecciona Temporada"
                      return-object
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.tipoCarnet" label="Nombre"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogcarnet" max-width="500px">
<v-card  color="#393E46">
<v-card-title class="headline">
  Diseño Carnet
</v-card-title>
  <v-card-text>
    <v-row>
      <v-col cols="12">
<v-tabs v-model="tab"
        centered
        dark
        icons-and-text
        background-color="#6D9886"
        color="#393E46">
  <v-tabs-slider></v-tabs-slider>
  <v-tab href="frontal">Frontal</v-tab>
  <v-tab href="posterior">Posterior</v-tab>
  <v-tab-item key="frontal" value="frontal">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field disabled v-model="editedItem.textColor" label="Color Letra Carnet" ></v-text-field>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-color-picker v-model="editedItem.textColor" type="hex" hide-inputs ></v-color-picker>
      </v-col>
    </v-row>
  </v-tab-item>
  <v-tab-item key="posterior" value="posterior">

  </v-tab-item>
</v-tabs>
      </v-col>
    </v-row>
  </v-card-text>
</v-card>
          </v-dialog>
          <v-dialog v-model="dialogdelete" persistent max-width="350">
        <v-card  color="#393E46">
          <v-card-title class="headline">Desea eliminar esta TipoCarnet?</v-card-title>
          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="close">No</v-btn>
            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          small
          color="blue"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-edit
        </v-icon>
        <v-icon
        small
        color="green"
        class="mr-2"
        @click="carnetItem(item)"
        >
          fas fa-id-card
        </v-icon>
      </template>
          <template v-slot:[`item.dactiva`]="{ item }">
            <v-switch v-model="item.activo" @click="activaItem(item)" ></v-switch>
          </template>
          <template v-slot:[`item.dsorteo`]="{ item }">
            <v-switch v-model="item.sorteo" @click="activaItem(item)" ></v-switch>
          </template>
            <template v-slot:[`item.dlink`]="{ item }">
                https://tunay.app/{{ idnegocio }}/membresia/{{ funcmd5(item) }}
            </template>
          <template v-slot:[`item.dbasico`]="{ item }">
            <v-switch v-model="item.basico" @click="activaItem(item)" ></v-switch>
          </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="dameTipoCarnets">Cargar de Nuevo</v-btn>
      </template>
    </v-data-table>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import md5 from 'js-md5';
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {

  title: 'Tipos de Carnet | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      negocio: {},
      Temporadas:[],
      abreviado:'NN',
      tab:null,
      dialogcarnet:false,
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'TipoCarnets',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      token:'',
      dialog: false,
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      TipoCarnets: [],
      search: '',
      overlay: false,
      editedIndex: -1,
      editedItem: {
        tipoCarnet: '',
        temporada: {},
        sorteo: false,
        basico:true,
        activa: true,
        backFront:'',
        backBack:'',
        textColor:'',
        descripcion:''
    },
    defaultItem: {
      tipoCarnet: '',
      temporada: {},
      sorteo: false,
      basico:true,
      activa: true,
      backFront:'',
      backBack:'',
      textColor:'',
      descripcion:''

    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Tipo Carnet', align: 'left',  value: 'tipoCarnet'},
        { text: 'Temporada', value: 'temporada.temporada' },
      { text: 'Activa', value: 'dactiva' },
  { text: 'Sorteo', value: 'dsorteo' },

    { text: 'Link', value: 'dlink' },
      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
              this.dameTipoCarnets();
              this.dameTemporadas();
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      this.dameTipoCarnets();
      this.dameTemporadas();

    }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
      if (this.usuario.id === undefined){
        this.$router.push({ path: '/' });
      }else{
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
        this.dameTipoCarnets();
        this.dameTemporadas();
      }

    },
  },
  methods : {
      funcmd5(item) {
          return md5(item.id.toString()).substring(4,12)
      },
    dameTemporadas(){
      this.progr = true;
      let urlTemporada = 'temporadas/negociotag/' + this.idnegocio  ;
      axios
          .get(urlTemporada,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.Temporadas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
            this.progr = false;
          });
    },

    dameTipoCarnets(){
      this.progr = true;
        axios
        .get('tipocarnets/negocio/tag/' + this.idnegocio,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        } )
        .then(response => {
            this.TipoCarnets = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
          this.progr = false;
        });
    },
    editItem (item) {
      this.editedIndex = this.TipoCarnets.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    carnetItem (item) {
      this.editedIndex = this.TipoCarnets.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogcarnet = true
    },
    deleteItem (item) {
      this.editedIndex = this.TipoCarnets.indexOf(item);
      this.dialogdelete = true;
    },

    activaItem (item) {
      this.editedItem = Object.assign({}, item)
      var bodyFormData2 = new FormData();
      bodyFormData2.append("data",JSON.stringify(this.editedItem));

      axios
          .post('tipocarnets/editar',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        console.log(response);
        this.editedIndex = this.Temporadas.indexOf(item);
        this.Temporadas = response.data;

      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    borralo (){
      let md555 = md5(this.TipoCarnets[this.editedIndex].TipoCarnetId.toString());
      axios
      .delete('tipocarnets/TipoCarnet/'+md555,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.TipoCarnets = response.data;
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.TipoCarnets[this.editedIndex], this.editedItem);
        var bodyFormData2 = new FormData();
        bodyFormData2.append("data",JSON.stringify(this.editedItem));

        axios
      .post('tipocarnets/editar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
                this.dameTipoCarnets();
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      } else {
        var bodyFormData = new FormData();
        this.editedItem.negocio = this.negocio
        bodyFormData.append("data",JSON.stringify(this.editedItem));

        axios
      .post('tipocarnets/editar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                this.TipoCarnets = response.data;
                this.alertnuevo = true;
                console.log(response);
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva TipoCarnet' : 'Editar TipoCarnet'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
